import api from '@/api/tutorial_editor'

const state = {
	options: {
		skillOptions: [],
		categoryOptions: [],
		softwareOptions: [],
		designCategories: []
	},

	showSeoFields: false,
	memberName: '',
	activeStep: null,
	previewMissing: ''
}

const getters = {
	introActive: (state) => {
		return state.activeStep == null && state.activeStep !== false
	},
	stepActive: (state) => {
		return state.activeStep !== null && state.activeStep !== false
	},
	activeStepIndex: (state) => {
		return state.tutorial.steps.indexOf(state.activeStep)
	}
}

const mutations = {
	activateStep: (state, step) => {
		state.activeStep = step
	},
	activateStepByIndex: (state, stepIndex) => {
		state.activeStep = state.tutorial.steps[stepIndex]
	},
	clearActiveStep: (state) => {
		state.activeStep = false
	},
	activateIntro: (state) => {
		state.activeStep = null
	},
	setFilters: (state, data) => {
		state.showSeoFields = data.show_seo_fields
		state.memberName = data.member_name
		state.previewMissing = data.preview_missing
		state.options.skillOptions = data.skill_options
		state.options.categoryOptions = data.category_options
		state.options.softwareOptions = data.software_options
		state.options.designCategories = data.design_categories
	}
}

const actions = {
	activateStep: ({commit, dispatch}, step) => {
		dispatch('checkNewAndClear')
		setTimeout(() => {
			commit('activateStep', step)
		}, 0)
	},
	activateStepByIndex: ({commit, dispatch}, stepIndex) => {
		dispatch('checkNewAndClear')
		setTimeout(() => {
			commit('activateStepByIndex', stepIndex)
		}, 0)
	},
	checkNewAndClear: ({dispatch, commit, getters}) => {
		if (getters.isNew) {
			dispatch('createTutorial')
		}
		commit('clearActiveStep')
	},
	fetchFilters: ({commit, dispatch}) => {
		const error = () => dispatch('setRequestFailedFlash')
		const success = data => commit('setFilters', data)
		api.fetchFilters().then(success).catch(error)
	}
}

export default {
	state,
	actions,
	mutations,
	getters
}
